import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { HeaderItem } from "../../../../shared/components";

export const filterIcon = css`
    position: relative;
    display: flex;
    margin-left: 6px;
`;

export const filterIconActive = css`
    &:after {
        content: "";

        position: absolute;
        top: 0;
        right: 0;

        display: block;

        width: 0;

        border: 3px solid ${Colors.Red.V150};
        border-radius: 50%;
    }
`;

export const ClickableHeaderItem = styled(HeaderItem)`
    cursor: pointer;
`;

export const sortIcon = css`
    margin: 0 4px -2px;
`;
